import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ThemeName, DEFAULT_THEME } from '@2enbota/shared';

interface SettingsState {
  theme: ThemeName;
  ttsEnabled: boolean;
  hapticEnabled: boolean;
  soundEffectsEnabled: boolean;
  autoAdvance: boolean;
  showAiModel: boolean;
  cardNavHotkeys: boolean;
  adminEditEnabled: boolean;

  setTheme: (theme: ThemeName) => void;
  setTtsEnabled: (enabled: boolean) => void;
  setHapticEnabled: (enabled: boolean) => void;
  setSoundEffectsEnabled: (enabled: boolean) => void;
  setAutoAdvance: (enabled: boolean) => void;
  setShowAiModel: (enabled: boolean) => void;
  setCardNavHotkeys: (enabled: boolean) => void;
  setAdminEditEnabled: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist<SettingsState>(
    (set) => ({
      theme: DEFAULT_THEME,
      ttsEnabled: true,
      hapticEnabled: true,
      soundEffectsEnabled: true,
      autoAdvance: true,
      showAiModel: false,
      cardNavHotkeys: false,
      adminEditEnabled: true,

      setTheme: (theme: ThemeName) => {
        document.documentElement.setAttribute('data-theme', theme);
        set({ theme });
      },
      setTtsEnabled: (ttsEnabled: boolean) => set({ ttsEnabled }),
      setHapticEnabled: (hapticEnabled: boolean) => set({ hapticEnabled }),
      setSoundEffectsEnabled: (soundEffectsEnabled: boolean) => set({ soundEffectsEnabled }),
      setAutoAdvance: (autoAdvance: boolean) => set({ autoAdvance }),
      setShowAiModel: (showAiModel: boolean) => set({ showAiModel }),
      setCardNavHotkeys: (cardNavHotkeys: boolean) => set({ cardNavHotkeys }),
      setAdminEditEnabled: (adminEditEnabled: boolean) => set({ adminEditEnabled }),
    }),
    {
      name: '2enbota-settings',
      merge: (persistedState: any, currentState: SettingsState): SettingsState => ({
        ...currentState,
        ...persistedState,
        soundEffectsEnabled: persistedState?.soundEffectsEnabled !== undefined
          ? Boolean(persistedState.soundEffectsEnabled)
          : true,
      }),
    }
  )
);
